export const ExchangeCalendarHowItWorks: React.FC = () => {
  return (
    <div>
      Automate email replies, access client insights, update client records, and manage tasks directly from Outlook, so you never have to switch tabs or
      navigate multiple systems.
    </div>
  )
}
